import { LineItem } from 'shared/types/cart';

/**
 * Determines whether to render simplified order details or multi-cart order details
 * based on the line items in the cart.
 *
 * @param lineItems - Array of line items from the cart
 * @returns true if simplified order details should be rendered, false if multi-cart should be rendered
 */
export const shouldRenderSimplifiedOrderDetails = (
  lineItems: LineItem[] | undefined,
): boolean => {
  // If no items or only one item, always render simplified
  if (!lineItems || lineItems.length === 1) {
    return true;
  }

  // If first item has bundle ID, check if all items have the same bundle ID
  if (lineItems[0]?.bundleId) {
    return lineItems.every((item) => item?.bundleId === lineItems[0]?.bundleId);
  }

  // If more than one item and first item has no bundle ID, render MultiCartOrderDetails
  if (lineItems.length > 1 && !lineItems[0]?.bundleId) {
    return false;
  }

  // Default fallback
  return true;
};
